import { Video as c } from "../EditPanel/Video";
import { conLanding } from "../Models/Landing";

export default class Video extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}